<div id="content" class="main-content">
    <div class="container">
       <div class="col-12 pl-0">
          <div class="crumbs breadcrumbs-style-2">
             <ul class="breadcrumb">
              <li class="mt-3">
                <a *ngIf="userRole === 'support'" class="pointer" href="/dash-support"><i class="flaticon-home-fill"></i></a>
                <a *ngIf="userRole === 'adm' || userRole === 'cmrc' || userRole === 'asst'" class="pointer" href="/dashboard"><i class="flaticon-home-fill"></i></a>
              </li>
                <li class="mt-3">
                  <a *ngIf="userRole === 'support'" class="pointer" routerLink="/tickets">Demandes</a>
                  <a *ngIf="userRole === 'adm' || userRole === 'cmrc' || userRole === 'asst'" class="pointer" routerLink="/support">Demandes</a>
                </li>
                <li class="active mt-3 current_arian"><a href="javascript:void(0);" class="current_arian">Détail</a></li>
             </ul>
          </div>
       </div>
        <div class="row layout-spacing">
        <!-- COLUMN OF FORMULAIRE -->
        <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 col-12 layout-spacing">
            <div class="statbox widget box box-shadow">
                <div class="widget-content widget-content-area" style="border-top-right-radius: 6px;
                    border-top-left-radius: 6px;">
                    <div *ngIf="detailLoading" class="cp-spinner cp-bubble" style="position: absolute;z-index: 9;margin: auto;display: block;margin-left: 42%;margin-top: 10%;"></div>
                    <blockquote class="blockquote mt-5">
                        <div class="d-flex justify-content-between mb-3">
                          <h3>Détail du ticket <b>{{ticket?.ticketNumber}}</b></h3>
                          <span *ngIf="!ticket.companyLogo">
                            <i class="flaticon-building-1" style="font-size: 3em;"></i>
                          </span>
                          <span *ngIf="ticket.companyLogo">
                            <img class="border-basic" [src]="'data:image/jpeg;base64,' + ticket.companyLogo" alt="Company Logo" style="width: 85px; height: 50px; border-radius: 50px;">
                          </span>
                        </div>
                        <div class="row form-group mb-3 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                          <div class="row col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                            <div class="col-lg-5 col-md-5 col-sm-12 col-xs-12">
                              <b>Objet</b>
                            </div>
                            <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12">
                              {{ticket.subject}}
                            </div>
                          </div>
                          <div class="row col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                            <div class="col-lg-5 col-md-5 col-sm-12 col-xs-12">
                              <b>Demandé par</b>
                            </div>
                            <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12">
                              {{ticket.requestor}}
                            </div>
                          </div>
                        </div>
                        <div class="row form-group mb-3 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                          <div class="row col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                            <div class="col-lg-5 col-md-5 col-sm-12 col-xs-12">
                              <b>Niveau d'intensité</b>
                            </div>
                            <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12">
                              {{ticket.intensityLevel}}
                            </div>
                          </div>
                          <div class="row col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                            <div class="col-lg-5 col-md-5 col-sm-12 col-xs-12">
                              <b>Statut</b>
                            </div>
                            <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12">
                                <span *ngIf="!editingStatus" class="mb-2 ml-2 badge badge-pills" style="font-size: xx-small;"
                                      [ngClass]="{
                                        'badge-open': ticket.status === 'Ouvert',
                                        'badge-resolved': ticket.status === 'Résolu',
                                        'badge-reprised': ticket.status === 'Repris',
                                        'badge-inProgress': ticket.status === 'En cours',
                                        'badge-waiting': ticket.status === 'En attente',
                                        'badge-clos': ticket.status === 'Clos'
                                      }">{{ ticket.status || '- - -' }}
                                  <i  *ngIf="userRole === 'support'" class="flaticon-edit-1 ml-2 icon-large-bold" style="cursor: pointer;" (click)="editStatus()"></i>
                                </span>
                                <i class="fa fa-history ml-2 icon-large-bold" style="cursor: pointer; color: #5b9884;" (click)="showHistory()"></i>
                                <div *ngIf="editingStatus">
                                  <select class="form-control" [(ngModel)]="ticket.status">
                                    <option value="Ouvert">Ouvert</option>
                                    <option value="Résolu">Résolu</option>
                                    <option value="Repris">Repris</option>
                                    <option value="En cours">En cours</option>
                                    <option value="En attente">En attente</option>
                                    <option value="Clos">Clos</option>
                                  </select>
                                  <div class="d-flex justify-content-between mt-2">
                                    <div>
                                      <i class="flaticon-checked-1 mr-2 icon-large-bold" style="cursor: pointer;" (click)="saveStatus()"></i>
                                      <i class="flaticon-cancel-circle icon-large-bold" style="cursor: pointer;" (click)="editingStatus = false"></i>
                                    </div>
                                    <img *ngIf="statusLoad" src="../assets/img/update-loading.webp" width="15" height="15">
                                  </div>
                                </div>
                            </div>
                          </div>
                        </div>
                        <div class="row form-group mb-3 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                          <div class="row col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                            <div class="col-lg-5 col-md-5 col-sm-12 col-xs-12">
                              <b>Crée par</b>
                            </div>
                            <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12">
                              {{ticket.creator}}
                            </div>
                          </div>
                          <div class="row col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                            <div class="col-lg-5 col-md-5 col-sm-12 col-xs-12">
                              <b>Crée le </b>
                            </div>
                            <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12">
                              {{ticket.createdAt}}
                            </div>
                          </div>
                        </div>
                        <div class="row form-group mb-3 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                          <div class="row col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                            <div class="col-lg-5 col-md-5 col-sm-12 col-xs-12">
                              <b>Description</b>
                            </div>
                            <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12">
                              {{ticket.description}}
                            </div>
                          </div>
                        </div>
                        <div *ngIf="ticket.jiraNumber && userRole === 'support'" class="row form-group mb-3 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div class="row col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                                <div class="col-lg-5 col-md-5 col-sm-12 col-xs-12">
                                    <b>Numéro ticket Jira</b>
                                </div>
                                <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12">
                                    <a *ngIf="!editingJiraNumber" [href]="jiraBrowseUrl + ticket.jiraNumber" target="_blank">
                                        <b>{{ ticket.jiraNumber }}</b>
                                    </a>
                                    <i *ngIf="!editingJiraNumber" class="flaticon-edit-1 ml-2 icon-large-bold" style="cursor: pointer;" (click)="editJiraNumber()"></i>
                                    <div *ngIf="editingJiraNumber">
                                    <input type="text" class="form-control" [(ngModel)]="newJiraNumber">
                                    <i class="flaticon-checked-1 mr-2 icon-large-bold" style="cursor: pointer;" (click)="saveJiraNumber()"></i>
                                    <i class="flaticon-cancel-circle icon-large-bold" style="cursor: pointer;" (click)="editingJiraNumber = false"></i>
                                    <img *ngIf="jiraLoad" src="../assets/img/update-loading.webp" width="15" height="15">
                                    </div>
                                </div>
                            </div>
                            <div class="row col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                              <div class="col-lg-5 col-md-5 col-sm-12 col-xs-12">
                                <b>Commentaire</b>
                              </div>
                              <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12">
                                <span *ngIf="!editingComment">{{ ticket.jiraComment || '- - -' }}
                                  <i class="flaticon-edit-1 ml-2 icon-large-bold" style="cursor: pointer;" (click)="editComment()"></i>
                                </span>
                                <div *ngIf="editingComment">
                                  <textarea class="form-control" rows="3" [(ngModel)]="newComment"></textarea>
                                  <i class="flaticon-checked-1 mr-2 icon-large-bold" style="cursor: pointer;" (click)="saveComment()"></i>
                                  <i class="flaticon-cancel-circle icon-large-bold" style="cursor: pointer;" (click)="editingComment = false"></i>
                                  <img *ngIf="jiraLoad" src="../assets/img/update-loading.webp" width="15" height="15">
                                </div>
                              </div>
                            </div>
                        </div>
                      <div *ngIf="ticket?.demandAttach?.length > 0" style="overflow: auto;" class="row form-group mb-3 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-5">
                        <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                          <b>Pieces jointe du ticket</b>
                        </div>
                        <div class="col-lg-9 col-md-9 col-sm-12 col-xs-12 mt-2 listAtt">
                          <table id="alter_pagination" class="table table-striped table-bordered table-hover" style="width:100%">
                            <thead>
                              <tr>
                                <th>Date d'ajout</th>
                                <th>Nom</th>
                                <th>Type</th>
                                <!-- <th *ngIf="userRole === ticket.author"></th> -->
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let file of ticket?.demandAttach; let i = index">
                                <td>{{ file.addedAt  || '----' }}</td>
                                <td (click)="file.fileType.split('/')[0] === 'image' || file.fileType === 'application/pdf' ? showFileModal(file) : null" style="cursor: pointer;">
                                  <a style="color: #027476;" href="javascript:void(0)">{{(file?.fileName?.length>30)? (file?.fileName | slice:0:60)+'...':(file?.fileName)}}</a>
                                </td>
                                <td>{{ file.fileType }}</td>
                                <!-- <td *ngIf="userRole === ticket.author">
                                  <button class="btn btn-danger btn-sm" (click)="deleteFile(ticket?.demandAttach, i)">
                                    <i class="flaticon-delete icon-large-bold" style="cursor: pointer;"></i>
                                  </button>
                                </td> -->
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                        
                        <!-- File upload input for the requester and the creator -->
                      <div *ngIf="userRole === ticket.author  && ticket?.demandAttach?.length < 3 " class="row form-group mb-3 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3">
                        <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                          <b>Ajouter une pièce jointe</b>
                        </div>
                        <div class="col-lg-9 col-md-9 col-sm-12 col-xs-12 mt-2 listAtt">
                          <input type="file" (change)="handleFileInput($event)" class="form-control-file" accept=".jpeg,.jpg,.png,.gif,.pdf,.doc,.docx">
                          <button class="btn btn-primary w-auto" 
                                  (click)="addFile(ticket?.supportAttach)" 
                                  [disabled]="!selectednewFile">
                              Ajouter <img *ngIf="attachLoad" src="../assets/img/update-loading.webp" width="15" height="15" class="ml-2">
                          </button>
                        </div>
                      </div>
                        
                    </blockquote>
                    <blockquote class="blockquote mt-5">
                        <div *ngIf="userRole === 'support'" class="d-flex justify-content-between mb-3">
                          <h3>Jira</h3>
                        </div>
                        <div *ngIf="userRole === 'support' && !ticket.jiraNumber" class="mb-4">
                            <div class="form-group">
                                <label for="jiraNumber">Numéro ticket Jira</label>
                                <input id="jiraNumber" type="text" class="form-control" [(ngModel)]="newJiraNumber" required>
                            </div>
                            <div class="form-group">
                                <label for="comment">Commentaire</label>
                                <textarea id="comment" class="form-control" rows="3" [(ngModel)]="newComment"></textarea>
                            </div>
                            <button class="btn btn-primary" (click)="addJiraAndComment()">Ajouter  <img *ngIf="jiraLoad" src="../assets/img/update-loading.webp" width="15" height="15"></button>
                        </div>
                        <div *ngIf="ticket?.supportAttach?.length > 0" style="overflow: auto;" class="row form-group mb-3 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-5">
                          <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                            <b>Pieces jointe du Support</b>
                          </div>
                            <div class="col-lg-9 col-md-9 col-sm-12 col-xs-12 mt-2 listAtt">
                              <table id="alter_pagination" class="table table-striped table-bordered table-hover" style="width:100%">
                                <thead>
                                  <tr>
                                    <th>Date d'ajout</th>
                                    <th>Nom</th>
                                    <th>Type</th>
                                    <!-- <th *ngIf="userRole === 'support'"></th> -->
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr *ngFor="let file of ticket?.supportAttach; let i = index">
                                    <td>{{file.addedAt || '----'}}</td>
                                    <td (click)="file.fileType.split('/')[0] === 'image' || file.fileType === 'application/pdf' ? showFileModal(file) : null"  style="cursor: pointer;">
                                      <a style="color: #027476;" href="javascript:void(0)">{{(file?.fileName?.length>30)? (file?.fileName | slice:0:60)+'...':(file?.fileName)}}</a>
                                    </td>
                                    <td>{{file.fileType}}</td>
                                    <!-- <td>
                                      <button class="btn btn-danger btn-sm" (click)="deleteFile(ticket?.supportAttach, i)">
                                        <i class="flaticon-delete icon-large-bold" style="cursor: pointer;"></i>
                                      </button>
                                    </td> -->
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                        </div>
                        <div *ngIf="userRole === 'support'" class="mt-3">
                          <h4>Ajouter une pièce jointe</h4>
                          <input type="file" (change)="handleFileInput($event)" class="form-control mb-2" accept=".jpeg,.jpg,.png,.gif,.pdf,.doc,.docx">
                          <button class="btn btn-primary" 
                                  (click)="addFile(ticket?.supportAttach)" 
                                  [disabled]="!selectednewFile">
                              Ajouter <img *ngIf="attachLoad" src="../assets/img/update-loading.webp" width="15" height="15" class="ml-2">
                          </button>
                        </div>

                        <div class="d-flex justify-content-between mt-5 mb-3">
                            <h3>Commentaires</h3>
                        </div>
                        <div *ngFor="let note of notes">
                          <div 
                              [ngClass]="{
                                'note-support': getAuthor(note.author) === 'Support',
                                'note-adm': getAuthor(note.author) === 'Directeur Commercial',
                                'note-asst': getAuthor(note.author) === 'Assistant',
                                'note-cmrc': getAuthor(note.author) === 'Commercial'
                              }" 
                              class="note mb-2 p-2">
                            <div class="d-flex justify-content-between">
                              <div>
                                <b>{{ getAuthor(note.author) | titlecase }}:</b> {{ note.createdAt | date: 'dd/MM/yyyy - HH:mm '}}
                              </div>
                            </div>
                            <div>
                              {{ note.text }}
                            </div>
                          </div>
                        </div>
                        <div class="mt-3">
                          <h4>Ajouter une note</h4>
                          <textarea [(ngModel)]="newNoteContent" (input)="onNoteInput($event)"
                                    class="form-control mb-2" rows="3"
                                    [ngClass]="{'is-invalid': newNoteContent && !isNoteValid}"></textarea>
                          <span *ngIf="newNoteContent && !isNoteValid" class="text-danger d-block mb-2">
                            La note doit contenir au moins une lettre ou un chiffre.
                          </span>
                          <div class="d-flex justify-content-start">
                            <button class="form-control btn-primary btn" (click)="addNote()" [disabled]="!isNoteValid || noteLoad">
                              <i class="flaticon-send-fill-1 icon-large-bold mr-2" style="cursor: pointer;"></i>Envoyer</button>
                            <img *ngIf="noteLoad" src="../assets/img/update-loading.webp" width="15" height="15" class="ml-2">
                          </div>
                        </div>
                    </blockquote>                      
                </div>
            </div>
        </div>
        </div>
    </div>
 </div>
 <div class="modal fade" id="fileModal" tabindex="-1" role="dialog" aria-labelledby="fileModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-body">
            <img [src]="'data:' +selectedFile?.fileType+ ';base64,' +selectedFile?.base64Image" class="img-fluid" alt="File Preview">
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Retour</button>
          <button type="button" class="btn btn-primary" (click)="downloadFile(selectedFile)">Télechager</button>
        </div>
      </div>
    </div>
  </div>
  

  <div class="modal fade" id="PDFModal" tabindex="-1" role="dialog" aria-labelledby="fileModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-body">
            <embed [src]="sanitizer.bypassSecurityTrustResourceUrl('data:' +selectedFile?.fileType+ ';base64,' +selectedFile?.base64Image)" type="application/pdf" width="100%" height="600px"/>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Retour</button>
          <a href="javascript:void(0)"  (click)="downloadFile(selectedFile)" class="btn btn-primary">Télecharger</a>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="surveyModal" tabindex="-1" role="dialog" aria-labelledby="fileModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="fileModalLabel"><b>Confirmation d'envoi d'enquête</b></h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body text-center">
          <p><b>Good Job,</b></p>
          <p>Voulez-vous envoyer l'enquête de support à :</p>
          <p><a href="javascript:void(0)" class="font-weight-bold text-primary">{{ticket?.creator}}</a></p>
        </div>
        <div class="modal-footer justify-content-center">
          <button type="button" class="btn btn-outline-secondary" data-dismiss="modal" >Non</button>
          <button type="button" class="btn btn-outline-success" (click)="sendSurvey()">Oui, Envoyer l'enquête</button>
        </div>
      </div>
    </div>
  </div>
  
<!-- History Modal -->
<div class="modal fade" id="history" tabindex="-1" role="dialog" aria-labelledby="fileModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title"><b>Historique</b></h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div *ngIf="historyLoading" class="cp-spinner cp-bubble" style="position: absolute;z-index: 9;margin: auto;display: block;margin-left: 42%;margin-top: 3%;"></div>
        <div *ngIf="!historyLoading && ticketHistory.length === 0" class="text-center">
          <p>Il n'y a aucun historique disponible pour ce ticket.</p>
        </div>
        <div *ngIf="!historyLoading && ticketHistory.length > 0">
          <div *ngFor="let event of ticketHistory">
            <div class="history-event">
              <div class="history-event-header">
                <span class="history-event-user"><img class="border-basic" [src]="event.avatar ? 'data:image/jpeg;base64,' + event.avatar : '../../assets/img/unknown_user.jpg'" alt="User Avatar" style="width: 35px; height: 35px; border-radius: 50px; margin-right: 5px;">{{ event.user }}</span>
                <span class="history-event-date">{{ event.updatedAt | date:'dd MMM yyyy HH:mm' }}</span>
              </div>
              <div class="history-event-details">
                  <span class="badge badge-pill"
                        [ngClass]="{
                          'badge-open': event.oldValue === 'Ouvert',
                          'badge-resolved': event.oldValue === 'Résolu',
                          'badge-reprised': event.oldValue === 'Repris',
                          'badge-inProgress': event.oldValue === 'En cours',
                          'badge-waiting': event.oldValue === 'En attente',
                          'badge-clos': event.oldValue === 'Clos'
                        }">{{ event.oldValue }}</span>
                         →
                        <span class="badge badge-pill"
                        [ngClass]="{
                          'badge-open': event.newValue === 'Ouvert',
                          'badge-resolved': event.newValue === 'Résolu',
                          'badge-reprised': event.newValue === 'Repris',
                          'badge-inProgress': event.newValue === 'En cours',
                          'badge-waiting': event.newValue === 'En attente',
                          'badge-clos': event.newValue === 'Clos'
                        }">{{ event.newValue }}</span>
              </div>
            </div>
            <hr>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Retour</button>
      </div>
    </div>
  </div>
</div>
